import { render, staticRenderFns } from "./DWInstrument.vue?vue&type=template&id=5d672055"
import script from "./DWInstrument.vue?vue&type=script&lang=ts"
export * from "./DWInstrument.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports